
import React from 'react';
import { motion } from 'framer-motion';
import { SeoHead } from '@/components/seo/SeoHead';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import MediaCard from '../components/media/MediaCard';
import { speaker } from '@/data/speaker';

const mediaData = speaker.media;

const MediaPage: React.FC = () => {
  return (
    <>
      <SeoHead
        route="/media"
        lang="pt-BR"
        title="Mídia & Destaques — Johnny Vaz"
        description="Entrevistas, podcasts e aparições de Johnny Vaz na mídia sobre Inteligência Artificial, automação e transformação digital."
      />
      <Navbar />

      {/* Hero */}
      <section style={{ backgroundColor: '#0B0B0B', paddingTop: '7rem', paddingBottom: '4rem' }}>
        <div className="container mx-auto px-6 max-w-4xl">
          <motion.div initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <p style={{ fontFamily: "'JetBrains Mono', ui-monospace, monospace", fontSize: '0.7rem', letterSpacing: '0.12em', textTransform: 'uppercase', color: '#FF4500', marginBottom: '1.25rem' }}>
              Mídia · Johnny Vaz
            </p>
            <h1 style={{ fontFamily: "'Anton', 'Archivo Black', sans-serif", fontSize: 'clamp(3rem, 9vw, 6.5rem)', lineHeight: 0.88, letterSpacing: '-0.01em', textTransform: 'uppercase', color: '#F2EDE3', marginBottom: '2rem' }}>
              MÍDIA &<br />
              <span style={{ color: '#FF4500' }}>DESTAQUES</span>
            </h1>
            <div style={{ height: '2px', backgroundColor: '#FF4500', width: '64px', marginBottom: '2rem' }} />
            <p style={{ fontFamily: "'Space Grotesk', system-ui, sans-serif", fontSize: 'clamp(1rem, 2.2vw, 1.2rem)', lineHeight: 1.65, color: '#8C8377', maxWidth: '520px' }}>
              Entrevistas e podcasts sobre Inteligência Artificial, automação de negócios
              e o futuro da tecnologia nas empresas.
            </p>
          </motion.div>
        </div>
      </section>

      <main>
        <section style={{ backgroundColor: '#0B0B0B', padding: '3rem 0 5rem' }}>
          <div className="container mx-auto px-6 max-w-5xl">
            <div className="grid md:grid-cols-2 gap-1">
              {mediaData.map((item, i) => (
                <motion.div
                  key={item.title}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: i * 0.15 }}
                >
                  <MediaCard {...item} />
                </motion.div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default MediaPage;
